"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppVersion = getAppVersion;
function getAppVersion() {
    var version = process.env.ARTIFACT_VERSION || '0.0.0';
    return version.replace('-SNAPSHOT', '');
}
//# sourceMappingURL=getAppVersion.js.map